import { Header } from '@components/Header';
import { OrganizationCards } from '@components/OrganizationCards';
import { useAuthContext } from '@providers/AuthProvider';
import { routes } from '@routes';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate } from 'react-router-dom';
import { Content } from './styles/Content';

export const OrganizationsListPage = () => {
  const { me } = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (me?.id && !me.organizations.length) {
      navigate(routes.noOrgs.make());
    }
  }, [me, navigate]);

  const organizationSectionTitle = `My Organizations${me.organizations.length > 0 ? ` (${me.organizations.length})` : ''}`;

  return (
    <>
      <Helmet>
        <title>My Organizations - AutoScript</title>
      </Helmet>
      <Header title="My Organizations" />

      <Content>
        <div>
          <h4>{organizationSectionTitle}</h4>
          <OrganizationCards />
        </div>
      </Content>
    </>
  );
};
